if (!window.Maximize.loadedScript.includes('collection-grid-fill.js')) {
  window.Maximize.loadedScript.push('collection-grid-fill.js');

  function getGridProductIds(grid) {
    const ids = new Set();
    grid.querySelectorAll('.grid-item[data-product-id]').forEach((el) => {
      if (el.dataset.productId) ids.add(el.dataset.productId);
    });
    return ids;
  }

  function getPaginationNextUrl(doc, grid) {
    if (grid?.dataset?.nextPageUrl) return grid.dataset.nextPageUrl;

    const itemsGrid = doc.getElementById?.('ItemsGrid') || doc.querySelector('#ItemsGrid');
    if (itemsGrid?.dataset?.nextPageUrl) return itemsGrid.dataset.nextPageUrl;

    const nav = doc.querySelector('nav.pagination');
    if (!nav) return null;

    const next =
      nav.querySelector('a[aria-label*="Next"][href]') ||
      nav.querySelector('li:last-child a[href]');
    if (!next) return null;

    const href = next.getAttribute('href');
    if (!href || next.classList.contains('cursor-not-allowed') || next.getAttribute('aria-disabled') === 'true') {
      return null;
    }
    return href;
  }

  function updatePaginationNext(container, newHref) {
    if (!newHref) return;
    const nav = container.querySelector('nav.pagination');
    if (!nav) return;
    const next =
      nav.querySelector('a[aria-label*="Next"]') || nav.querySelector('li:last-child a[href]');
    if (next) next.setAttribute('href', newHref);
  }

  window.fillCollectionGrid = async function (root = document) {
    const grid = root.getElementById
      ? root.getElementById('ItemsGrid')
      : document.getElementById('ItemsGrid');
    if (!grid || grid.dataset.collectionFill !== 'true') return;

    const container = grid.closest('#ProductGridContainer') || document.getElementById('ProductGridContainer');
    if (!container) return;

    const target = parseInt(grid.dataset.productsPerPage, 10) || 30;
    const maxFetches = 10;
    let ids = getGridProductIds(grid);
    let nextUrl = getPaginationNextUrl(document, grid);
    let fetches = 0;

    while (grid.querySelectorAll('.grid-item').length < target && nextUrl && fetches < maxFetches) {
      try {
        const res = await fetch(nextUrl);
        if (!res.ok) break;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('ItemsGrid');
        if (!newGrid) break;

        let added = 0;
        for (const item of newGrid.querySelectorAll('.grid-item')) {
          if (grid.querySelectorAll('.grid-item').length >= target) break;
          const pid = item.dataset.productId;
          if (!pid || ids.has(pid)) continue;
          grid.appendChild(item.cloneNode(true));
          ids.add(pid);
          added++;
        }

        if (!added) break;
        nextUrl = getPaginationNextUrl(doc, newGrid);
        fetches++;
      } catch (e) {
        console.error(e);
        break;
      }
    }

    const gridItems = grid.querySelectorAll('.grid-item');
    if (gridItems.length > target) {
      for (let i = gridItems.length - 1; i >= target; i--) {
        gridItems[i].remove();
      }
    }

    updatePaginationNext(container, nextUrl);
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(container);
    }
    document.dispatchEvent(
      new CustomEvent('maximize:animation:reveal', { detail: { rootElement: container } })
    );
  };

  function bootFill() {
    window.fillCollectionGrid().catch((e) => console.error(e));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFill);
  } else {
    bootFill();
  }
}
